// extracted by mini-css-extract-plugin
export default {"content":"ProductModelPanelHeader__content___i_0pB","secondary":"ProductModelPanelHeader__secondary___M_61M"};